import { Box, Button } from "@mui/material";
import { Timer, Warning } from "@mui/icons-material";
import { useSessionManager } from "../../hooks/useSessionManager";

interface SessionTimerProps {
  showTimer?: boolean;
}

export default function SessionTimer({ showTimer = true }: SessionTimerProps) {
  const { timeLeft, isWarning, formatTime, logout } = useSessionManager();

  if (!showTimer) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        ml: 1,
      }}
    >
      {isWarning ? (
        <Button
          variant="contained"
          color="warning"
          onClick={logout}
          startIcon={<Warning />}
          sx={{
            backgroundColor: "#ff9800",
            color: "white",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#f57c00",
            },
          }}
        >
          Wyloguj za: {formatTime(timeLeft)}
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="primary"
          onClick={logout}
          startIcon={<Timer />}
          sx={{
            borderColor: "#1976d2",
            color: "#1976d2",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.1)",
              borderColor: "#1565c0",
            },
          }}
        >
          Wyloguj za: {formatTime(timeLeft)}
        </Button>
      )}
    </Box>
  );
}
